import {Routes, Route, Navigate} from 'react-router-dom'
import {FormUser} from './components/FormUser'
import {ListUser} from './components/ListUser'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import { ListLogs } from './components/ListLogs'

const breadcrumbs: Array<PageLink> = [
  {
    title: 'Arteco Admin GUI',
    path: '',
    isSeparator: false,
    isActive: false,
    disableLink: true,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const breadcrumbs_with_lista: Array<PageLink> = [
  {
    title: 'Arteco Admin GUI',
    path: '',
    isSeparator: false,
    isActive: false,
    disableLink: true,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Lista Utenti',
    path: '/user',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const UserRoutes = () => (
  <Routes>
    <Route
      index
      element={
        <>
          <PageTitle breadcrumbs={breadcrumbs}>Lista Utenti</PageTitle>
          <ListUser />
        </>
      }
    />
    <Route
      path='add'
      element={
        <>
          <PageTitle breadcrumbs={breadcrumbs_with_lista}>Nuovo utente</PageTitle>
          <FormUser />
        </>
      }
    />
    <Route
      path='edit/:id'
      element={
        <>
          <PageTitle breadcrumbs={breadcrumbs_with_lista}>Modifica utente</PageTitle>
          <FormUser />
        </>
      }
    />

<Route
      path='logs/:id'
      element={
        <>
          <PageTitle breadcrumbs={breadcrumbs_with_lista}>Log accessi</PageTitle>
          <ListLogs />
        </>
      }
    />
    <Route path='*' element={<Navigate to='/error/404' />} />
  </Routes>
)

export {UserRoutes}
